import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9fb557e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "top-tabs tabs-buttons" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["disabled", "title"]
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = ["disabled", "title"]
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = { class: "content-container" }
const _hoisted_10 = { class: "top-content" }
const _hoisted_11 = { class: "flex-row-centered" }
const _hoisted_12 = {
  key: 0,
  class: "flex-col-centered"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Transfer Type Selection:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "All", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "flex-col-centered" }
const _hoisted_17 = { class: "center-buttons" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "container" }
const _hoisted_20 = { class: "utility-bar" }
const _hoisted_21 = {
  key: 0,
  class: "link-btn"
}

import { ref, onMounted, computed, onUnmounted, nextTick } from "vue";
import { marketSelection } from "@/services/helpers/Helper";
import TablePersistentChecking, { ITableExpose } from "@/components/TablePersistentChecking.vue";
import MarketSelector from "@/components/MarketSelector.vue";
import { getBankTransferPayments } from "@/services/network";
import IBankTransferPayments from "@/Interfaces/Ledgering/IBankTransferPayments";
import DbTableCsvHelper from "@/services/helpers/DbTableCsvHelper";
import useNotifier from "@/services/composables/Notifier";
import TransferPopUp from "@/components/Ledger/TransferPopUp.vue";
import { useRoute } from "vue-router";
import router from "@/router";
import { authService } from "@/auth/authSingleton";

enum tabs {
    WAITING = "WAITING",
    CONFIRMED = "CONFIRMED",
    COMPLETED = "COMPLETED",
}
enum routeTabs {
    OUTSTANDING = "outstanding",
    CONFIRMED = "confirmed",
    COMPLETED = "completed",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TransferPayments',
  setup(__props) {

onMounted(() => {
    marketSelection.value = 'GB'
    routeTab.value = route.params.transferStatus as string;    
    if (!routeTab.value || routeTab.value === "") {
        ToggleTabs(tabs.WAITING);
    }
    else if (Object.values(routeTabs).includes(routeTab.value)) {
        switch (routeTab.value) {
            case routeTabs.OUTSTANDING:
                ToggleTabs(tabs.WAITING);
                break;
            case routeTabs.CONFIRMED:
                ToggleTabs(tabs.CONFIRMED);
                break;
            case routeTabs.COMPLETED:
                ToggleTabs(tabs.COMPLETED);
                break;
        }
    } 
    else {
        router.push({ name: "Page Not Found" });
    }
});
onUnmounted(() => {
    marketSelection.value = 'GB'
})

const route = useRoute(); 
const routeTab = ref()
const currentTab = ref<tabs>(tabs.WAITING);
const bankTransferPayments = ref<IBankTransferPayments[]>();
const displayedBankTransferPayments = ref<IBankTransferPayments[]>();
const bankTransferCols: (keyof IBankTransferPayments)[] = ["Market", "TransferId", "TransferTypeId", "AccountFrom", "AccountTo", "Amount", "TicketId", "TargetDate", "ConfirmedValueDate", "ApprovedValueDate", "FinalApprovedValueDate", "ConfirmedUser", "ApprovedUser", "FinalApprovedUser"];
const displayedBankTransferColumns = ref<(keyof IBankTransferPayments)[]>(bankTransferCols); 
const bankTransferLabels = ["Market", "Transfer ID", "Transfer Type ID", "Account From", "Account To", "Amount", "Ticket ID", "Target Date", "Confirmed Value Date", "Approved Value Date", "Final Approved Value Date","Confirmed User", "Approved User", "Final Approved User"];
const displayedBankTransferLabels = ref<string[]>(bankTransferLabels); 
const selectedType = ref("");
const transferTypes = ref<{ key: string; val: string }[]>([]);
const selectedRow = ref<IBankTransferPayments>();
const table = ref<ITableExpose<IBankTransferPayments>>();
const disableButton = computed(() => {
    return table?.value?.GetChecked()[0] == null 
});
const userEmail = authService.getEmailAddress();

function ButtonPressedAction(){
    selectedRow.value = table?.value?.GetChecked()[0]; 
}
function ToggleTabs(tab: tabs) {
    currentTab.value = tab
    const r = {name: "Transfer Payments", params: { transferStatus: routeTabs.OUTSTANDING.toString()}};
    router.push(r);
    if(currentTab.value == tabs.WAITING){
        router.push(r);
        displayedBankTransferColumns.value = ["Market", "TransferId", "TransferTypeId", "AccountFrom", "AccountTo", "Amount", "TicketId", "TargetDate"];
        displayedBankTransferLabels.value = ["Market", "Transfer ID", "Transfer Type ID", "Account From", "Account To", "Amount", "Ticket ID", "Target Date"]
    }
    if(currentTab.value == tabs.CONFIRMED){
        router.push(r.params.transferStatus = routeTabs.CONFIRMED.toString());
        displayedBankTransferColumns.value = ["Market", "TransferId", "TransferTypeId", "AccountFrom", "AccountTo", "Amount", "TicketId", "TargetDate", "ConfirmedValueDate", "ApprovedValueDate","ConfirmedUser", "ApprovedUser"];
        displayedBankTransferLabels.value = ["Market", "Transfer ID", "Transfer Type ID", "Account From", "Account To", "Amount", "Ticket ID", "Target Date", "Confirmed Value Date", "Approved Value Date","Confirmed User", "Approved User"]
    }
    if(currentTab.value == tabs.COMPLETED){
        router.push(r.params.transferStatus = routeTabs.COMPLETED.toString());
        displayedBankTransferColumns.value = bankTransferCols
        displayedBankTransferLabels.value = bankTransferLabels
    }
    BankTransferPaymentsGetter()
}
function refreshAfterButtonAction(){
    BankTransferPaymentsGetter();
}
async function BankTransferPaymentsGetter(){
    displayedBankTransferPayments.value = undefined
    bankTransferPayments.value = undefined
    const res = await getBankTransferPayments.get( {market: marketSelection.value.toString(), status: currentTab.value})
    bankTransferPayments.value = res.data
    if(currentTab.value == tabs.COMPLETED){
        displayedBankTransferPayments.value = res.data.sort((a, b) => {
        return b.TransferId - a.TransferId;
    });
    }
    else{
        displayedBankTransferPayments.value = res.data
        if(currentTab.value == tabs.CONFIRMED){
            PreventDoubledUserApproval()
        }
    }
    GenerateTransferTypeSelectionPairs()
}
async function PreventDoubledUserApproval() {
    await nextTick();
    var table = document.getElementById("bankTransferTable");
    if (!table) return;
    var rows = table.getElementsByTagName("tr");
    for (var i = 0; i < rows.length; i++) {
        var approvedUserCell = rows[i].querySelector("td.ApprovedUser");
        if(approvedUserCell?.textContent != null){
            if (approvedUserCell && approvedUserCell.textContent == userEmail) {
                var checkboxCell = rows[i].querySelector("td.vtl-checkbox");
                var checkbox = checkboxCell?.querySelector("input[type='checkbox']") as HTMLInputElement;;
                if (checkbox) {
                    checkbox.disabled = true;
                }
            }
        }
    }
}
function MarketSelectionUpdate() {
    selectedType.value = "";
    BankTransferPaymentsGetter();
}
function GenerateTransferTypeSelectionPairs(){
    if(currentTab.value != tabs.COMPLETED) return
    selectedType.value = ""
    const uniqueTransferPairs = [...new Set(bankTransferPayments.value?.map(x => [x.AccountFrom, x.AccountTo].join(" - ")))];
    transferTypes.value = uniqueTransferPairs.map(pair => ({
        key: pair,
        val: pair
    }));
}
function updateDisplayedBankTransfers() {
    table.value?.ClearChecked();
    selectedType.value == "" 
    ? displayedBankTransferPayments.value = bankTransferPayments.value 
    : displayedBankTransferPayments.value = bankTransferPayments.value?.filter(x =>([x.AccountFrom, x.AccountTo].join(" - ") == selectedType.value ))
}
function exportFilteredDisplayable() {
    const filtered = table.value?.GetFiltered() ?? [];
    if (filtered.length) {
        DbTableCsvHelper.generateCsvDownload(filtered, `CompletedBankTransfers.csv`);
    } else useNotifier().warn({ msg: 'There is nothing in the table to export.' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-left ${currentTab.value === tabs.WAITING ? 'selected' : 'unselected'}`),
            disabled: currentTab.value === tabs.WAITING,
            title: currentTab.value === tabs.WAITING
                   ? `Currently viewing ${currentTab.value.toLowerCase()} transfer payments`
                  : 'Click to view outstanding Transfer Payments',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (ToggleTabs(tabs.WAITING)))
          }, " Outstanding ", 10, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-middle ${currentTab.value === tabs.CONFIRMED ? 'selected' : 'unselected'}`),
            disabled: currentTab.value === tabs.CONFIRMED,
            title: currentTab.value === tabs.CONFIRMED
                ? `Currently viewing ${currentTab.value.toLowerCase()} transfer payments`
                : 'Click to view confirmed payments',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (ToggleTabs(tabs.CONFIRMED)))
          }, " Confirmed ", 10, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-right ${currentTab.value === tabs.COMPLETED ? 'selected' : 'unselected'}`),
            disabled: currentTab.value === tabs.COMPLETED,
            title: currentTab.value === tabs.COMPLETED
                ? `Currently viewing ${currentTab.value.toLowerCase()} payments`
                : 'Click to view completed payments',
            onClick: _cache[2] || (_cache[2] = ($event: any) => (ToggleTabs(tabs.COMPLETED)))
          }, " Completed ", 10, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(MarketSelector, {
            onChange: MarketSelectionUpdate,
            enableSE: ""
          }),
          (currentTab.value === tabs.COMPLETED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _hoisted_13,
                _withDirectives(_createElementVNode("select", {
                  onChange: updateDisplayedBankTransfers,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedType).value = $event)),
                  class: "dropdown wider"
                }, [
                  _hoisted_14,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferTypes.value, (transferType) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: transferType.key,
                      key: transferType.key
                    }, _toDisplayString(transferType.val), 9, _hoisted_15))
                  }), 128))
                ], 544), [
                  [_vModelSelect, selectedType.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (currentTab.value != tabs.COMPLETED)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ButtonPressedAction,
                    disabled: disableButton.value,
                    class: "incident-nav-button"
                  }, _toDisplayString(currentTab.value == tabs.WAITING ? "Confirm Transfer" : "Approve Transfer"), 9, _hoisted_18))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (currentTab.value == tabs.COMPLETED)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createTextVNode(" ["),
                _createElementVNode("a", { onClick: exportFilteredDisplayable }, "Export csv"),
                _createTextVNode("] ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TablePersistentChecking, {
          ref_key: "table",
          ref: table,
          id: "bankTransferTable",
          Rows: displayedBankTransferPayments.value,
          Cols: displayedBankTransferColumns.value,
          HasCheckBox: currentTab.value != tabs.COMPLETED,
          SingleSelection: true,
          Labels: displayedBankTransferLabels.value,
          HasPreCol: ""
        }, null, 8, ["Rows", "Cols", "HasCheckBox", "Labels"])
      ]),
      _createVNode(TransferPopUp, {
        modelValue: selectedRow.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedRow).value = $event)),
        currentTab: currentTab.value,
        onConfirm: refreshAfterButtonAction
      }, null, 8, ["modelValue", "currentTab"])
    ])
  ], 64))
}
}

})